export const INC_COUNT = 'inc_count';
export const DEC_COUNT = 'dec_count';


// WEBPACK FOOTER //
// ./src/actions/types.js